import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, WmsDialogBodyComponent, WmsDialogComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent } from '@wms/components';

@Component({
  selector: 'wms-global-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent
  ],
  templateUrl: './global-confirm-dialog.component.html',
  styleUrls: ['./global-confirm-dialog.component.less']
})
export class GlobalConfirmDialogComponent extends BaseComponent {

  @Input() caption: any;
  @Input() content: any;
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onModalOk: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  closeModal() {
    this.onModalClose.emit();
  }

  onOk() {
    this.onModalOk.emit();
  }

}
